/****************************************************
 * Module Name:  stoneAvailable.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip, Typography } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import StoneDetailModal from "../common/stoneDetailModal";
import Constants from "../../utility/constants";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import { RiInboxUnarchiveLine } from "react-icons/ri";
import StoneAvailableModal from "./stoneAvailableModal";
import CommonStoneSelection from "../common/commonStoneSelection";
import VideoLibraryTwoToneIcon from '@mui/icons-material/VideoLibraryTwoTone';
import PDFModal from "../common/pdfModal";
import { HiPrinter } from "react-icons/hi2";
import ReportProxy from "../../utility/proxy/manager/reportProxy";
import StickerPrintModal from "../common/stickerPrintModal";
import BiotechIcon from '@mui/icons-material/Biotech';
import RelabModal from "./relabModal";
import CommonSnackbar from "../common/commonSnackBar";
import StoneMediaModal from "../common/stoneMediaModal";
import Select from "react-select";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import PageTitle from "../common/pageTitle";

const StoneAvailable = () => {
  const [statusData, setStatusData] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);
  const [show, setShow] = useState(false);
  const [stoneId, setStoneId] = useState("");
  const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [listLoader, setListLoader] = useState(false);
  const [columnNames, setColumnNames] = React.useState([]);
  const [successResponse, setSuccessResponse] = useState(false);
  const [byte, setByte] = useState();
  const [showStickerModal, setShowStickerModal] = useState(false);
  const [showRelabModal, setShowRelabModal] = useState(false);
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("");

  const [stoneMediaURL, setStoneMediaURL] = useState([]);
  const [showStoneMediaModal, setShowStoneMediaModal] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);
  const [location, setLocation] = useState("");

  // eslint-disable-next-line
  const [local_Permission, setLocal_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.OPERATION_LAB_AVAILABLE
    )
  );
  // eslint-disable-next-line
  const [sellPermission, setSellPermission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.DIRECTSALE
    )
  );

  //top most summary table 
  const [noOfSelectedStones, setNoOfSelectedStones] = useState("0");
  const [selectedTotalSize, setSelectedTotalSize] = useState("0");
  const [selectedAvgDiscount, setSelectedAvgDiscount] = useState("0");
  const [selectedavgPrice, setSelectedavgPrice] = useState("0");
  const [selectedtotalPrice, setSelectedtotalPrice] = useState("0");

  useEffect(() => {
    PageTitle("OPERATION_LAB_AVAILABLE");
    getAllLocationData();
  }, []);

  const getAllLocationData = () => {
    LocationProxy.GetAllLocationDetailMini((response) => {
      setAllLocationData(response);
    });
  };

  const setAllLocationData = (response) => {
    let optionsArray = [];
    let defaultSelection = {};
    response.map((data) => {
      let option = { value: data.id, label: data.name };
      optionsArray.push(option);
      if (option.value === Constants.loggedInUser.locationid) {
        defaultSelection = option;
        setLocation(option);
      }
      return true;
    });
    setLocationOptions(optionsArray);

    if (defaultSelection)
      handleSearch(defaultSelection);
  }

  const loadTotalData = (data) => {
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size

    data.forEach((iData) => {
      let pricePerCarat = iData.price
      totalSize += iData.size;
      totalPrice += (iData.size * pricePerCarat);
      total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));

    });
    setNoOfSelectedStones(data.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
  };

  useEffect(() => {
    if (selectionModel.length <= 0) {
      loadTotalData(statusData);
      return;
    }
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size
    statusData.forEach((iData) => {
      if (selectionModel.includes(iData.stoneid)) {
        let pricePerCarat = iData.price
        totalSize += iData.size;
        totalPrice += (iData.size * pricePerCarat);
        total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
      }
    });
    setNoOfSelectedStones(selectionModel.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );

  }, [selectionModel]);

  const handleOpen = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShowStoneDetailModal(false);
  };

  const handleValidation = (customer) => {
    //TODO do validation if needed here
    return true;
  };

  const handleSearch = (selectedLocation) => {

    setLocation(selectedLocation);
    setListLoader(true);
    StoneProxy.GetAllStonesForAvailableByLocation(
      Constants.loggedInUser.id, selectedLocation.value,
      (responseData) => {
        if (responseData) {

          const uniqueFilterValues = {
            labshape: Utility.getDistinctOptions(responseData, 'labshape'),
          }

          prepareColumns(uniqueFilterValues);
          setStatusData(responseData);
          loadTotalData(responseData)
          setListLoader(false);
        } else {
          setErrorSnackbar(true)
          setListLoader(false);
        }
      }
    );
  };

  const markStoneAvailable = (data) => {
    setLoadingButton(true);
    StoneProxy.MarkStoneAvailable(data, (responseData) => {
      if (responseData) {
        handleSearch(location);
        setLoadingButton(false);
        setSuccessResponse(true);
      } else {
        setErrorSnackbar(true);
        setLoadingButton(false);
      }
    });
    setShow(false);
  };

  const relabStones = (data) => {
    setLoadingButton(true);
    StoneProxy.UpdateStoneStatus(data, "RE-LAB", (responseData) => {
      if (responseData) {
        handleSearch(location);
        setShowSuccessSnackbar(true);
        setSuccessMessage("Stone sent to RE-LAB successfully");
        setSnackbarVariant("success");
        setShowRelabModal(false)
        setLoadingButton(false);
      } else {
        setShowSuccessSnackbar(true);
        setShowRelabModal(false)
        setSuccessMessage(responseData ? responseData.errorMessage : Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
        setLoadingButton(false);
      }
    });
  };

  const handleStoneDetailModal = (params) => {
    setStoneId(params.value);
    setShowStoneDetailModal(true);
  };

  const handleSelection = (data) => {
    const [tempStockData, tempSelectionModel] = Utility.handleSelection(data, statusData, selectionModel);

    setStatusData(tempStockData);
    setSelectionModel(tempSelectionModel);
  }

  const prepareColumns = (uniqueFilterValues) => {
    let columnNames = [];

    Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
      if (columnsData.hasOwnProperty(iColPermission)) {
        const columnData = columnsData[iColPermission];
        columnNames.push(columnData);
        if (columnData.field === "stoneid") {
          columnNames.push({
            field: "suratid",
            headerName: "SURATID",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: renderCellExpand,
          })
        }
        if (columnData.field === "shape") {
          columnNames.push({
            field: "labshape",
            headerName: "LAB SHAPE",
            headerAlign: "center",
            align: "center",
            width: 90,
            renderCell: renderCellExpand,
            type: "singleSelect",
            valueOptions: uniqueFilterValues.labshape,
          })
        }
      }
    });
    setColumnNames(columnNames);
  }

  const columnsData = {
    "item-1": {
      field: "batchid",
      headerName: "BATCH ID",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 80,
    },
    "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
      field: "stoneid",
      headerName: "STONEID",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
      align: "center",
      renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
        <Button
          sx={{ textDecorationLine: "underline", color: "black" }}
          onClick={() => handleStoneDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    "c6161d51-13c0-479e-abe8-2a14b2d8b914": {
      field: "resultdate",
      headerName: "RESULT DATE",
      headerAlign: "center",
      width: 100,
      type: "date",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      align: "center",
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.value),
    },
    "54fbd914-6ce7-44a8-9354-db6125ba1992": {
      field: "tag",
      headerName: "TAG",
      headerAlign: "center",
      align: "center",
      width: 100,
      hideable: false,
      editable: true,
      renderCell: renderCellExpand,
    },
    "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
      field: "size",
      headerName: "SIZE",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 40,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
    },
    "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
      field: "stonetype",
      headerName: "STONETYPE",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
    },
    "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
      field: "shape",
      headerName: "SHAPE",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
      field: "rapnetprice",
      headerName: "RAP",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.rapnetprice)
    },
    "798a8663-0f0c-41be-8512-16dd60d5f25e": {
      field: "discount",
      headerName: "DIS",
      headerAlign: "center",
      align: "center",
      width: 50,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discount)
    },
    "39c634f1-2644-4307-acbb-983b4de4229e": {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "right",
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
    "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
      field: "total",
      headerName: "TOTAL",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "right",
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.total)
    },
    "6defca68-d5d9-4c30-ae83-938a01f45a07": {
      field: "colortype",
      headerName: "COL TYPE",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
      field: "color",
      headerName: "COLOR",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      align: "center",
      width: 65,
      renderCell: renderCellExpand,
    },
    "d4992de9-92ab-4f9e-ba12-6c746e935611": {
      field: "colordescriptions",
      headerName: "COL DESCRIP",
      headerAlign: "center",
      align: "center",
      width: 110,
      renderCell: renderCellExpand,
    },
    "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
      field: "clarity",
      headerName: "CLARITY",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 75,
      renderCell: renderCellExpand,
    },
    "3597803f-8932-40c6-8de6-81006f4d6d5b": {
      field: "cut",
      headerName: "CUT",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      align: "center",
      width: 50,
      renderCell: renderCellExpand,
    },
    "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
      field: "pol",
      headerName: "POL",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      align: "center",
      width: 40,
      renderCell: renderCellExpand,
    },
    "5541c182-21b8-496e-b342-b0b89f3d302f": {
      field: "sym",
      headerName: "SYM",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      align: "center",
      width: 40,
      renderCell: renderCellExpand,
    },
    "8296e627-0be5-4a66-830f-ea6867cea137": {
      field: "flo",
      headerName: "FLO",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 60,
      renderCell: renderCellExpand,
    },
    "b718f242-4a82-42e7-b98a-40bbf0f67c21": {
      field: "shade",
      headerName: "SHADE",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: renderCellExpand,
    },
    "567202e6-c31c-4c19-9998-1cacae05af6e": {
      field: "depth",
      headerName: "DEPTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "3c62ef48-9538-4df7-9484-a9ae1ba31086": {
      field: "height",
      headerName: "HEIGHT",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "eed9b7eb-17e4-4ec6-9c9d-c299f885544c": {
      field: "width",
      headerName: "WIDTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
      field: "depthpercent",
      headerName: "DEPTH%",
      headerAlign: "center",
      align: "center",
      width: 75,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
      field: "tablepercent",
      headerName: "TABLE%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
      field: "lab",
      headerName: "LAB",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
      renderCell: renderCellExpand,
    },
    "19ce7030-402c-495c-84ac-a29093bdb0ac": {
      field: "locationid",
      headerName: "LOCATION ID",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 120,
    },
    "ab3e506e-bddb-456d-b967-922dcee74d56": {
      field: "location",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 100,
      renderCell: renderCellExpand,
    },
    "f97a0118-3891-4f77-abf7-8636c26d594c": {
      field: "country",
      headerName: "COUNTRY",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "cb7e6add-67ba-4194-ac49-fd0d967db4e8": {
      field: "quality",
      headerName: "QUALITY",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "e7210f4a-6e0a-4591-8428-e6845004ed04": {
      field: "crownheight",
      headerName: "CR.HEIGHT",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "c4e65984-1682-4c1e-812b-8938e9078b2d": {
      field: "crownangle",
      headerName: "CR.ANG",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "0f1de38d-3ae3-4209-a4d5-afe9f3018f22": {
      field: "culetsize",
      headerName: "CULET SZ",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "e3f77521-2c57-46bc-a02b-3c884685d2be": {
      field: "culetcondition",
      headerName: "CULET",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "e83c2978-9088-49f0-9dc1-bcced73025fd": {
      field: "gridlemin",
      headerName: "GIRDLEMIN",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "cee57bac-9c19-40d5-b51a-51ed913dbf73": {
      field: "intensitylongtitle",
      headerName: "INTENSITYLONGTITLE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "06d2a589-0d42-4dde-8724-acf2448c839a": {
      field: "laserinscription",
      headerName: "INS",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "61f8a5f2-8516-419a-b6fd-39ef109cc2f4": {
      field: "paviliondepth",
      headerName: "PV.DEPTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "e9028170-e978-4978-a2c9-1889c1821495": {
      field: "gridlecondition",
      headerName: "GIRDLE COND",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "fe8f55f3-358a-4418-bcdf-c3da4b01db67": {
      field: "gridlepercent",
      headerName: "GIRDLE%",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "daf69bba-bb1f-4d54-9dc7-9383ad429585": {
      field: "pavilionangle",
      headerName: "PV.ANGLE",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "ecfdfc0c-6a25-4a6d-9c8f-3406c23410af": {
      field: "white",
      headerName: "WHITE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
      field: "comment",
      headerName: "COMMENT",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "13d48508-b8c9-4661-8a6c-9fb22a3408a3": {
      field: "measurements",
      headerName: "MEASUREMENTS",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
    },
    "8eaa8a03-d163-436d-8912-51ea06306f44": {
      field: "certificateid",
      headerName: "CERT",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    "db078198-4416-4d53-b3d0-70d3a5418f65": {
      field: "open",
      headerName: "OPEN",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "dd934505-1865-48cb-878f-f5d3c18af2d5": {
      field: "note",
      headerName: "NOTE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "cf694b75-ba5d-4a73-8fcf-e7566974c4b6": {
      field: "media",
      headerName: "MEDIA",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: (params) => (
        <Tooltip title={"Stone Media"} sx={{ cursor: "pointer" }}>
          <VideoLibraryTwoToneIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setStoneMediaURL(params.row.stonemediaurl);
              setShowStoneMediaModal(true);
            }} />
        </Tooltip>
      ),
    },

  };

  const rows = statusData;
  const columns = columnNames;

  // Packet Print
  const printPacket = () => {
    let data = statusData.filter(item => selectionModel.includes(item.stoneid));
    ReportProxy.GeneratePacketPrintPDF(data, response => {
      if (response) {
        setByte(response.fileBytes);
        openModal()
      }
    })
  }

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>

      {/*need to send pdf in byte string to modal */}
      <PDFModal show={isModalOpen} onHide={closeModal} pdfByteString={byte} pdfName={"packetPrint"} />

      <TabMenuSnackbar
        show={errorSnackbar}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Failed"}
        handleClose={() => setErrorSnackbar(false)}
      />
      {successResponse ? (
        <TabMenuSnackbar
          show={successResponse}
          message={
            "Stones Marked Available"
          }
          variant={"success"}
          autoHide={true}
          title={"Success"}
          handleClose={() => setSuccessResponse(false)}
        />
      ) : null}

      {showSuccessSnackbar ? (
        <CommonSnackbar
          show={true}
          message={successMessage}
          variant={snackbarVariant}
          autoHide={Constants.SnackBarCloseTimer}
          title={snackbarVariant === "success" ? "Success" : "Failed"}
          handleClose={() => setShowSuccessSnackbar(false)}
        />
      ) : null}

      {showStoneDetailModal ? (
        <StoneDetailModal
          show={showStoneDetailModal}
          stoneId={stoneId}
          handleClose={handleClose}
        />
      ) : null}

      {showStoneMediaModal ? (
        <>
          <StoneMediaModal
            show={showStoneMediaModal}
            stoneMediaURL={stoneMediaURL}
            handleClose={() => setShowStoneMediaModal(false)}
          />
        </>
      ) : null}

      {showStickerModal ? (
        <StickerPrintModal
          show={showStickerModal}
          stoneIds={selectionModel}
          handleClose={() => setShowStickerModal(false)}
        />
      ) : null}
      <Box m={1} sx={{ display: "flex", }}>
        <Box
          sx={{
            display: "flex",
            width: "16%",
            gap: "10px",
          }}
        >
          <Box sx={{ alignSelf: "center", mt: 1 }}>
            <Typography >Location</Typography>
          </Box>
          <Box
            sx={{
              alignSelf: "center",
              width: "100%",
              mt: 1,
            }}
          >
            <Select menuPlacement="auto"
              blurInputOnSelect={false}
              className="basic-single"
              classNamePrefix="select"
              value={location}
              isSearchable={true}
              name="status"
              menuPortalTarget={document.body}
              styles={Constants.Styles}
              options={locationOptions}
              onChange={(selectedOption) => handleSearch(selectedOption)}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            m: "8px 15px 0 30px",
            color: "black",
            paddingTop: "8px",
            paddingLeft: "8px",
            fontWeight: 'normal',
            fontSize: Constants.defaultTableFontSize
          }}

        ><p>
            <span>No of Stones: </span> <b>{noOfSelectedStones}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
            <span>Total Weight: </span> <b>{selectedTotalSize}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
            <span>Total Price: </span> <b>{selectedtotalPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
            <span>Avg Price: </span> <b>{selectedavgPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
            <span>Avg Discount: </span> <b>{selectedAvgDiscount}</b></p>

        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: '#fff',
          color: '#000',
          width: "100%",
          position: "relative",
          "& .MuiTablePagination-selectLabel": {
            marginTop: "15px",
          },
          "& .MuiTablePagination-displayedRows": {
            marginTop: "15px",
          },
          "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
            fontWeight: Constants.defaultFontWeight,
          },
          "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
            color: "#1976d2",
            padding: "4px 5px",
            borderRadius: "4px",
          },
          "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
            color: "#1976d2",
            padding: "5px 5px",
            borderRadius: "4px",
          },
          "& .css-cc8tf1": {
            fontWeight: Constants.defaultFontWeight,
          },
          height: "70vh",
        }}
      >
        <DataGridPro
          disableRowSelectionOnClick={true}
          slots={{ toolbar: GridToolbar }}
          sx={{
            '& .MuiDataGrid-columnHeader': {
              color: '#fff',
              backgroundColor: 'grey',
            },
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
              py: "4px",
            },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
              py: "12px",
            },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
              py: "18px",
            },
            "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
              outline: "none !important",
            },
            fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
          }}
          density="compact"
          rows={rows}
          columns={columns}
          getRowId={(row) => row.stoneid}
          checkboxSelection={true}
          onRowSelectionModelChange={(newSelectionModel) => {
            setSelectionModel(newSelectionModel);
          }}
          loading={listLoader}
          rowSelectionModel={selectionModel}
          initialState={{
            columns: {
              columnVisibilityModel: {
                // Hide columns id, the other columns will remain visible
                approved: false,
                rejected: false,
                locationid: false,
                cutpolsym: false,
                culetsize: false,
                culetcondition: false,
                gridlemin: false,
                intensitylongtitle: false,
                laserinscription: false,
                country: false,
                quality: false,
                status: false,
                location: false,
                open: false,
                nextstate: false,
                remark: false,
                note: false,
                report: false,
                height: false,
                lab: false,
                crownheight: false,
                crownangle: false,
                paviliondepth: false,
                gridlecondition: false,
                gridlepercent: false,
                pavilionangle: false,
                white: false,
                suratid: false
              },
            },
            sorting: {
              sortModel: [{ field: "stoneid", sort: "asc" }],
            },
            pagination: {
              paginationModel: Constants.pageSize,
            },
          }}
          pageSizeOptions={Constants.pageSizeOptions}
          pagination
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: {
                debounceMs: 500,
              },
            },
          }}
        />

        <Box sx={{
          position: "absolute",
          left: "0.4rem",
          top: "1px"
        }}>
          <CommonStoneSelection title={"Enter multiple Stone Ids"} handleSelection={handleSelection} buttonDisabled={rows.length === 0} />
        </Box>

        <Box
          style={{
            position: "absolute",
            top: 6,
            left: "455px",
            display: "flex",
          }}
        >

          {Utility.isAddAllowed(local_Permission) ? (
            <Tooltip title={"Print Packet"}>
              <Button
                variant="outlined"
                size="small"
                component="label"
                sx={{ ml: "10px" }}
                color="secondary"
                startIcon={<HiPrinter size={14} />}
                disabled={selectionModel.length === 0}
                onClick={printPacket}
              >
                Packet
              </Button>
            </Tooltip>
          ) : null}

          {Utility.isAddAllowed(local_Permission) ? (
            <Tooltip title={"Print Sticker"}>
              <Button
                variant="outlined"
                size="small"
                component="label"
                sx={{ ml: "10px" }}
                color="secondary"
                startIcon={<HiPrinter size={14} />}
                onClick={() => setShowStickerModal(true)}
              >
                Sticker
              </Button>
            </Tooltip>
          ) : null}
        </Box>
        <Box
          style={{
            position: "absolute",
            top: 5,
            right: "270px",
          }}
        >
          {listLoader ? (
            <CircularProgress size="1rem" />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                onClick={() => handleSearch(location)}
                color="primary"
                fontSize="medium"
                sx={{ cursor: "pointer", mr: 1 }}
              />
            </Tooltip>
          )}
          {Utility.isAddAllowed(local_Permission) ? (
            <Tooltip title={"Change Location"}>
              <Button
                variant="outlined"
                size="small"
                component="label"
                sx={{
                  ml: "5px",
                  "& .Mui-disabled": {
                    color: "rgba (0,0,0,0.26) !important",
                  },
                }}
                startIcon={<RiInboxUnarchiveLine />}
                disabled={selectionModel.length < 1 || listLoader}
                onClick={handleOpen}
              >
                Available
              </Button>
            </Tooltip>
          ) : null}

          {Utility.isAddAllowed(local_Permission) ? (
            <Tooltip title="RE-LAB">
              <Button
                variant="outlined"
                size="small"
                component="label"
                sx={{ ml: "5px" }}
                startIcon={<BiotechIcon size="large" />}
                color="success"
                disabled={selectionModel.length < 1 || listLoader}
                onClick={() => { setShowRelabModal(true) }}>
                RE-LAB
              </Button>
            </Tooltip>
          ) : null}

          {show && (
            <StoneAvailableModal
              show={true}
              setShow={setShow}
              handleValidation={handleValidation}
              handleSave={markStoneAvailable}
              stoneIds={selectionModel}
              loading={loadingButton}
            />
          )}

          {showRelabModal ? (
            <RelabModal
              show={true}
              setShow={setShowRelabModal}
              handleSave={relabStones}
              stoneIds={selectionModel}
              loading={loadingButton}
            />
          ) : null}

        </Box>
      </Box>
    </div>
  );
};

export default StoneAvailable;
